import UserInfo from "components/UserInfo";
import { useEffect, useRef, useState } from "react";
import styles from "./Table.module.scss";

const Table = ({ callsReport = [], photos, sortColumn }) => {
  const ref = useRef();
  const [activeColumn, setActiveColumn] = useState("total_real_calls");

  function setHeaderHeight() {
    if (typeof window === "object") {
      return document.documentElement.style.setProperty(
        "--thead-height",
        `${ref.current?.offsetHeight}px`
      );
    }
  }

  useEffect(() => {
    setHeaderHeight();
  }, [callsReport]);

  const toHours = (seconds) => {
    return (seconds / (60 * 60)).toFixed(1);
  };

  const handleClick = (columnName) => {
    sortColumn(columnName);
    setActiveColumn(columnName);
  };

  return (
    callsReport && (
      <div className={styles.wrapper}>
        <table className={styles.content}>
          <thead className={styles.header} ref={ref}>
            <tr className={styles.row}>
              <th
                onClick={() => handleClick("first_name")}
                className={activeColumn === "first_name" ? styles.active : ""}
              >
                Name
              </th>
              <th
                onClick={() => handleClick("employee_extension_id")}
                className={
                  activeColumn === "employee_extension_id" ? styles.active : ""
                }
              >
                Ext
              </th>
              <th
                onClick={() => handleClick("outgoing_emails_count")}
                className={
                  activeColumn === "outgoing_emails_count" ? styles.active : ""
                }
              >
                Outgoing Emails
              </th>
              <th
                id="total_real_calls"
                onClick={() => handleClick("total_real_calls")}
                className={
                  activeColumn === "total_real_calls" ? styles.active : ""
                }
              >
                Total Calls
              </th>
              <th
                onClick={() => handleClick("total_calls_duration")}
                className={
                  activeColumn === "total_calls_duration" ? styles.active : ""
                }
              >
                Total Duration
              </th>
              <th
                onClick={() => handleClick("incoming_answered")}
                className={
                  activeColumn === "incoming_answered" ? styles.active : ""
                }
              >
                Incoming Answered
              </th>
              <th
                onClick={() => handleClick("incoming_cancelled")}
                className={
                  activeColumn === "incoming_cancelled" ? styles.active : ""
                }
              >
                Incoming Cancelled
              </th>
              <th
                onClick={() => handleClick("incoming_duration")}
                className={
                  activeColumn === "incoming_duration" ? styles.active : ""
                }
              >
                Incoming Duration
              </th>
              <th
                onClick={() => handleClick("outgoing_calls")}
                className={
                  activeColumn === "outgoing_calls" ? styles.active : ""
                }
              >
                Outgoing Calls
              </th>
              <th
                onClick={() => handleClick("outgoing_successful")}
                className={
                  activeColumn === "outgoing_successful" ? styles.active : ""
                }
              >
                Outgoing Successful
              </th>
              <th
                onClick={() => handleClick("outgoing_duration")}
                className={
                  activeColumn === "outgoing_duration" ? styles.active : ""
                }
              >
                Outgoing Duration
              </th>
            </tr>
          </thead>
          <tbody className={styles.body}>
            {callsReport?.map((employee, index) => {
              return (
                <tr key={employee?.employee_extension_id ?? index}>
                  <td>
                    <UserInfo
                      src={photos[employee?.id]}
                      name={employee?.first_name + " " + employee?.last_name}
                    />
                  </td>
                  <td>{employee?.employee_extension_id ?? "-"}</td>
                  <td>{employee?.outgoing_emails_count ?? "n/a"}</td>
                  <td>{employee?.total_real_calls ?? "-"}</td>
                  <td>
                    {employee?.total_calls_duration
                      ? toHours(employee?.total_calls_duration)
                      : "-"}
                  </td>
                  <td>{employee?.incoming_answered ?? "-"}</td>
                  <td>{employee?.incoming_cancelled ?? "-"}</td>
                  <td>
                    {employee?.incoming_duration
                      ? toHours(employee?.incoming_duration)
                      : "-"}
                  </td>
                  <td>{employee?.outgoing_calls ?? "-"}</td>
                  <td>{employee?.outgoing_successful ?? "-"}</td>
                  <td>
                    {employee?.outgoing_duration
                      ? toHours(employee?.outgoing_duration)
                      : "-"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    )
  );
};

export default Table;
